<script>
    import { getIbeHost, getCorpHost } from "shared/Utilities/fetchUtilities";
    import slider from "shared/Components/slider.vue";
    import f9button from "inputs/f9button.vue";
    import f9link from "inputs/f9link.vue";
    import { attachToMemberEvent } from "shared/member";
    import { attachToLogoutEvent, logout } from "shared/login";
    import { applyIdsToObject, camelCaseProperties } from 'shared/Utilities/objectUtilities';
    import mobileNav from "./mobileNav.vue";
    import desktopNav from "./desktopNav.vue";
    import sticky from "vue-sticky-directive";

    let menuDataPath = "/umbraco/api/externalcontent/menuv2",
        profilePath = "/FrontierMiles/Profile";

    export default {
        props: {
            "showSlider": Boolean,
            "navData": Object,
            "showSignupSlider": Function,
            "headerLinks": Array
        },
        data() {
            return {
                menuData: {
                    deals: { link:{}, section:{}, creditCard:{ link: {}} },
                    travel: { link:{}, sections:[] },
                    myFrontier: { link:{}, leftSection:{}, rightSection:{}, rightSectionImageAndLinkNotSignedIn:{umbracoLink:{}} }
                },
                member: {}
            };
        },
        computed: {
            loggedIn() {
                return !!this.member.isLoggedIn;
            },
            profileLink() {
                return this.ibeHost() + profilePath;
            }
        },
        created() {
            if(!this.headerLinks.length){
                fetch(this.corpHost() + menuDataPath).then(x => x.json())
                    .then(x => {
                        x.travel.sections.forEach(section => section.visible = false);

                        this.menuData = x;
                        applyIdsToObject(this.menuData);
                    })
                    .catch(error => console.error(error));
            }

            attachToMemberEvent("baseMemberLoaded", e => this.member = e.detail.data);

            attachToLogoutEvent(x => this.member = x ? { isLoggedIn: false } : this.member);
        },
        methods: {
            hideNav() {
                this.showTravel = this.showDeals = this.showFrontier = false
            },
            logout() {
                logout(this.ibeHost())
                    .then(x => this.$refs.navSlider.hide());
            },
            ibeHost() {
                return getIbeHost();
            },
            corpHost() {
                return getCorpHost();
            },
            signup() {
                this.$refs.navSlider.hide();
                this.showSignupSlider();
            }
        },
        components: {
            slider,
            f9button,
            f9link,
            mobileNav,
            desktopNav
        },
        directives: {
            sticky
        }
    }
</script>

<template>
    <div class="nav-container">
        <desktop-nav @signup="showSignupSlider" :menu-data="menuData" :profile-link="profileLink" :header-links="headerLinks" class="nav-desktop hide-sm hide-md"></desktop-nav>

        <slider ref="navSlider" class="nav-slider" v-model="navData.slider" :close-button="false" side="left" 
            header-color="#267d5f" :top="55" :pixel-width="275">
            <div slot="head" class="nav-slider-head horizontal bottom between" :class="{ 'logged-in': loggedIn }">
                <template v-if="loggedIn">
                    <f9link :href="ibeHost() + '/FrontierMiles/Profile'" nostyle class="vertical center left">
                        <span class="member-name">Hi, {{member.firstName}} | {{member.currentMiles}} mi.</span>
                        <span><i>FRONTIER Miles</i><span class="sm">sm</span> Profile</span>
                    </f9link>
                    <f9button nostyle @click="logout">Logout</f9button>
                </template>
                <template v-else>
                    <span class="nav-my-frontier"><i>FRONTIER Miles</i></span>
                    <f9button nostyle @click="signup" class="nav-signup">Sign up today!</f9button>
                </template>
            </div>
            <mobile-nav :menu-data="menuData" :profile-link="profileLink" :header-links="headerLinks"></mobile-nav>
        </slider>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .nav-container {
        margin-top: 5px;
        color: @white;

        .nav-desktop {
            align-self: flex-end;
        }
    }
    
    .nav-slider-head {
        width: 100%;
        text-transform: none;

        &.logged-in {
            font-size: 10px;
            font-weight: 400;

            .member-name {
                font-size: 12px;
            }

            .sm {
                font-size: 6px;
                vertical-align: super;
            }
        }

        .nav-my-frontier {
            font-size: 14px;
            font-weight: 600;
            font-style: italic;
            text-transform: uppercase;
            display: flex;

            .nav-my {
                margin-top: 5px;
                width: 24px;
                height: 19px;
            }
        }
        .nav-signup {
            font-size: 11px;
            font-weight: 400;
            margin-bottom: 6px;
            text-decoration: underline;
        }
    }
</style>

<style>
    .nav-slider .slider-body {
        padding: 0 !important;
    }
</style>